export const MIN_PRICE = 100

export const tariffColors = [
    '#7CB1FF',
    '#B4A2F8',
    '#9ED665',
    '#9ED665',
    'inherit'
]

export const tariffSaturated = [
    '#408CFF',
    '#967EED',
    '#68BB13',
    '#68BB13',
    'inherit'
]

export const MIN_PRICE = 100

export const tariffColors = [
    '#7CB1FF',
    '#B4A2F8',
    '#9ED665',
    '#9ED665',
    'inherit'
]

export const tariffSaturated = [
    '#408CFF',
    '#967EED',
    '#68BB13',
    '#68BB13',
    'inherit'
]

